import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { authService } from 'src/services/api/auth.service'
import { QUERY_KEYS } from 'src/services/consts/queries.const'
import { refetchEnabledWhenVisible } from 'src/composables/app/system/useOnlineStatus'

/**
 * Public invite token verification query for the AcceptInvite landing page.
 * Not gated on auth — runs before login when a ?token= query param is present.
 *
 * @param {import('vue').Ref<string|null>} tokenRef
 */
export function useInviteVerificationQuery(tokenRef) {
  const enableQuery = computed(
    () => typeof tokenRef.value === 'string' && tokenRef.value.length > 0
  )

  const inviteVerificationQuery = useQuery({
    queryKey: [QUERY_KEYS.INVITE_VERIFICATION, tokenRef],
    enabled: enableQuery,
    queryFn: () => authService.verifyInvite(tokenRef.value),
    refetchOnWindowFocus: enableQuery,
    refetchOnReconnect: refetchEnabledWhenVisible(enableQuery),
  })

  return {
    inviteVerification: inviteVerificationQuery.data,
    isInviteVerificationLoading: inviteVerificationQuery.isLoading,
    isInviteVerificationRefetching: inviteVerificationQuery.isRefetching,
    inviteVerificationError: inviteVerificationQuery.error,
    refetchInviteVerification: inviteVerificationQuery.refetch,
  }
}
